/**
 * Created by fanglijuan on 2016/11/7.
 */
"use strict";
angular.module("productManageMentAppNewAndModifyExternalSysModule", ['productManageMentAppExternalSysModule'])
    .controller("productManageMentAppNewAndModifyExternalSysCtrl", ["$scope", "$q", "trsHttpService", "modalDialog", "$validation", "$modalInstance", "item", "siteid", "successFn",
        function($scope, $q, trsHttpService, modalDialog, $validation, $modalInstance, item, siteid, successFn) {
            initStatus();
            initData();

            function initStatus() {
                $scope.info = {
                    title: item ? '修改外联模块配置' : '新建外联模块配置',
                    siteid: siteid
                };

                $scope.data = {
                    currConfig: {},
                    openTypes: [{ //打开方式
                        "desc": "内嵌",
                        "value": 1,
                        "isSelected": false
                    }, {
                        "desc": "跳转",
                        "value": 2,
                        "isSelected": false
                    }],
                };
                $scope.appConfigsJson = [];
                $scope.isOpenType = item ? item.PATTERN : $scope.data.openTypes[0].value;
            }

            function initData() {
                /*if (item) {
                    getCurrConfig();
                }*/
                initAllConfigs();
            }
            /**
             * [getCurrConfig description 获取外链配置详细信息]
             * @return {[type]} [description]
             */
            function getCurrConfig() {
                var params = {
                    "serviceid": "mlf_appconfig",
                    "methodname": "getExtSysInfo",
                    "EXTERNALSYSTEMID": item.EXTERNALSYSTEMID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currConfig = data;
                    var i = 0;
                    while (i < $scope.appConfigsJson.length) {
                        if ($scope.appConfigsJson[i].value === data.SYSORDER) {
                            $scope.appConfigsJson.splice(i, 1);
                            $scope.selectedConfig = angular.copy($scope.appConfigsJson[i - 1]);
                        } else {
                            i++;
                        }
                    }
                });
            }
            /**
             * [initAllConfigs description 获取所有外链配置列表信息]
             * @return {[type]} [description]
             */
            function initAllConfigs() {
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "queryExtSysBySite",
                    CurrPage: 1,
                    pagesize: 200,
                    SITEID: siteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    var configsDates = data.DATA;
                    for (var key in configsDates) {
                        $scope.appConfigsJson.push({
                            name: configsDates[key].EXTSYSNAME,
                            value: configsDates[key].SYSORDER
                        });
                    }
                    $scope.appConfigsJson.unshift({
                        name: "最前面",
                        value: -1
                    });
                    $scope.selectedConfig = angular.copy($scope.appConfigsJson[0]);
                    item !== "" ? getCurrConfig() : "";
                });
            }
            //获取前一级栏目
            $scope.querySelectConfig = function() {
                $scope.data.currConfig.SYSORDER = $scope.selectedConfig.value;
            };

            $scope.cancel = function() {
                $modalInstance.dismiss("cancel");
            };
            $scope.confirm = function() {
                $validation.validate($scope.createExternalSysForm).success(function() {
                    saveCurrConfig($scope.data.currConfig).then(function(data) {
                        modalDialog.alertType('保存成功', "", "success", false, function() {
                            $modalInstance.close(data);
                        });
                    });
                }).error(function() {
                    //modalDialog.alertType('保存失败', "请检查填写项", "warning", false);
                });
            };

            function saveCurrConfig(newConfig) {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_appconfig",
                    methodname: "saveExternalSys",
                    EXTERNALSYSTEMID: item ? item.EXTERNALSYSTEMID : 0,
                    Siteid: siteid,
                    ExtSysName: $scope.data.currConfig.EXTSYSNAME,
                    ExtSysAdd: $scope.data.currConfig.EXTSYSADD,
                    SysOrder: $scope.selectedConfig.value,
                    PATTERN: $scope.isOpenType,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    data = data.replace(/\"/g, "")
                        //todo
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [selectOpenType description]选择打开方式
             * @param  {[type]} openType [description]
             * @return {[type]}          [description]
             */
            $scope.selectOpenType = function(openType) {
                $scope.isOpenType = openType.value;
            };

        }
    ]);
